module.exports = __webpack_public_path__ + "img/vitb-machine-vision-poster.2284e4e7.jpg";